module.exports = __webpack_public_path__ + "static/media/top1.1b8ee472.png";